import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store'
import axios from 'axios'
import { get, post, putRequest, deleteRequest, exportRequest, formDataPost } from './utils/request'
// import * as echarts from 'echarts';
import App from './App.vue'
import './assets/css/global.css'
import './assets/css/iconfont.css'

ElementUI.Dialog.props.closeOnClickModal.default = false;
ElementUI.Dialog.props.appendToBody.default = true;
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

Vue.config.productionTip = false
//挂载到Vue原型上
// Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
Vue.prototype.getRequest = get;
Vue.prototype.postRequest = post;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest; 
Vue.prototype.exportRequest = exportRequest; 
Vue.prototype.formDataPost = formDataPost

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
